import React from 'react';
import './PaymentTotalDue.css';
import { getPaymentTotalPrice } from 'Utils/PaymentTotalPrice';
import { getPaymentTotalDue } from 'Utils/PaymentTotalDue';
import { useSelector } from 'react-redux';

export const PaymentTotalDue = () => {
  const promoCode = useSelector((s) => s.promoCode);
  const subscription = useSelector((s) => s.subscription);
  const { selectedPlan, selectedPlanPrice } = useSelector((s) => s.plans);
  const { totalTax } = useSelector((s) => s.checkout);

  const totalPrice = getPaymentTotalPrice({ selectedPlan, selectedPlanPrice, promoCode, totalTax });
  const totalDueLabel = getPaymentTotalDue({ subscription, selectedPlan, promoCode });

  return (
    <div className="paymentTotalDue">
      <span className="reviewLabel">{totalDueLabel}</span>
      <span className="reviewValue">${totalPrice}</span>
    </div>
  );
};
